/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationPavillonInformationQuery from '../graphql/queries/GetSimulationPavillonInformationQuery.js';

const useGetSimulationPavillonInformationQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationPavillonInformationQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationPavillonInformation: R.omit(['__typename'], data?.getSimulationPavillonInformation_simulation_pavillon_information || {})
  };
};

export default useGetSimulationPavillonInformationQuery;
